export default __webpack_public_path__ + "static/media/Celtic-Beauty-Green-Wrap-Bracelet.fc757689.jpg";